import i18next from 'i18next';

import { getPdfFile } from 'common/api/sunpal/renderTemplate';
import { downloadFile } from 'common/utils/helpers';
import showToast from 'common/utils/showToast';

import {
    DOWNLOAD_REPORT_PDF,
    DOWNLOAD_REPORT_PDF_FAILURE,
    DOWNLOAD_REPORT_PDF_SUCCESS,
} from '../actionTypes';
import { reportTemplateActions } from '../reducer';

export default ({ downloadFormat, id, name = i18next.t('File'), type }) =>
    (dispatch) => {
        dispatch(reportTemplateActions[DOWNLOAD_REPORT_PDF]());

        const newValues = {
            quality: downloadFormat,
            renderName: name,
            templateFinishedId: id,
            templateType: type,
        };

        return getPdfFile(newValues)
            .then((response) => {
                dispatch(
                    reportTemplateActions[DOWNLOAD_REPORT_PDF_SUCCESS](
                        response.data,
                    ),
                );
                dispatch(downloadFile(response.data, `${name}.pdf`));

                showToast({ body: i18next.t('It was created successfully') });
            })
            .catch((error) => {
                dispatch(
                    reportTemplateActions[DOWNLOAD_REPORT_PDF_FAILURE](error),
                );
                showToast({
                    type: 'danger',
                    body: i18next.t('An error occurred'),
                });
            });
    };
